import { map } from 'rxjs/operators';
import { AcknowledgementStatusEntry, MatrixCellData, MetricData } from '../omnidashboard.models';
import { buildAckStatusMap, resolveAckMetric } from './acknowledgement-status.metric';
import { OmniMetricLoader, OmniMetricLoaderDeps } from './metric-loader';

/** Fetches TNC signature data and maps each cell to acknowledgement MetricData. */
export const ACKNOWLEDGEMENT_STATUS_LOADER: OmniMetricLoader = {
  key: 'acknowledgement-status',
  load(deps: OmniMetricLoaderDeps) {
    return deps.selfService.getAllErgTnc().pipe(
      map((items: AcknowledgementStatusEntry[]) => {
        const ackStatusMap = buildAckStatusMap(Array.isArray(items) ? items : []);
        return (cell: MatrixCellData): MetricData => resolveAckMetric(ackStatusMap, cell);
      })
    );
  },
};
